import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { largeElevation, mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const root = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing.md}px;
  border-radius: ${spacing.sm}px;
  gap: ${spacing.xs}px;
  background-color: var(--neutral-white-base);
  ${largeElevation};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: ${spacing.sm}px;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      padding: ${spacing.md}px;
    `,
  )}
`;

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing.xs}px;

  a {
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    ${responsiveText.BODY.MD};
    text-decoration: none;
    color: var(--brand-bluple-base);
  }

  time {
    ${responsiveText.BODY.XS};
    color: var(--neutral-black-70);
  }
`;

export const commentText = css`
  position: relative;
  overflow: hidden;
  transition: height 0.3s ease-in-out;

  p {
    margin: 0;
    padding: 0;
    font-family: ${fonts.PRIMARY_REGULAR.family};
    font-weight: ${fonts.PRIMARY_REGULAR.weight};
    ${responsiveText.BODY.MD};
    color: var(--neutral-black-base);
  }
`;

export const commentTextCollapsed = css`
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to bottom, transparent, var(--neutral-white-base));
    pointer-events: none;
  }
`;

export const readMoreButtonText = css`
  z-index: 1;
  margin-right: ${spacing.xs}px;
`;

export const expandingButton = css`
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 0;
  border: none;
  text-decoration: none;
  ${responsiveText.BODY.MD};
  font-weight: bold;
  color: var(--brand-purple-base);
  background-color: transparent;
`;
